// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stepper h2.title,.stepper p.subtitle{text-align:center}.stepper h2.title{font-size:18px;font-weight:700;color:#141c20;margin-bottom:5px}.stepper p.subtitle{font-size:14px;font-weight:400;color:#7c8b91;margin-bottom:33px}", ""]);
// Exports
module.exports = exports;
